import { cloneElement, isValidElement, useState, useEffect,useContext } from "react";
import { Link, useLocation } from 'react-router-dom'
import SocialButton from "../SocialButton";
import Logo from '../../assets/mic_logo.png'
import { navs } from '../../jsons/navs'
import { session, clearSession, setSession, store } from '../../utils/AuthSession'
import { gapi } from 'gapi-script';
import { GoogleLogin, GoogleLogout } from 'react-google-login'
import { Navigate } from 'react-router-dom'
import { AiFillHome, AiOutlineHistory, AiOutlineUser, AiOutlineDollarCircle, AiOutlineGift } from "react-icons/ai";
import {
    useNavigate
} from "react-router-dom";
import { ThemeContext } from "../../context/ThemeContext";

// import Auth from '@/utils/auth'
// console.log('authSession',authSession)

const Navigation = (props) => {
    const [authSession, setAuthSession] = useState(session())
    const [Store, setStore] = useState()
    const navigate = useNavigate();
    const location = useLocation()
    const {primaryColor,primaryColorHover} = useContext(ThemeContext)
    const bottomNavLabelClassName = 'text-[10px] leading-none'
    const bottomNavIconClassName = 'text-[21px] leading-none'

    const renderBottomNavIcon = (icon) => {
        if (!isValidElement(icon)) return icon
        const existingClassName = icon.props?.className || ''

        return cloneElement(icon, {
            className: `${existingClassName} ${bottomNavIconClassName}`.trim(),
        })
    }

    const isNavigationActive = (link) => (
        location.pathname === link || location.pathname.startsWith(`${link}/`)
    )

    const navigationButtonClassName = (isActive) => (
        `inline-flex min-w-0 flex-col items-center justify-center px-2 transition-opacity ${
            isActive ? 'text-white opacity-100' : 'text-white opacity-50 hover:opacity-80'
        }`
    )

    useEffect(()=> {
        // Hindari call API auth jika belum login
        if(!authSession) return
        store().then((data) => {
            setStore(data)
        })
    },[authSession])
    
    const handleOnSuccess = () => {
        setAuthSession(session())
        window.location.reload(false);
    }

    const handleLogout = () => {
        clearSession()
        setSession(session)
        window.location.reload(false);
    }


    return (
        <div className="fixed bottom-0 left-1/2 z-50 h-16 w-full -translate-x-1/2 border border-none md:max-w-2xl" style={{backgroundColor:`${primaryColor}`}}>
            
            {/* <div className="grid h-full max-w-lg grid-cols-6 mx-auto"> */}
            <div className="grid h-full w-full grid-cols-5">

                {navs.map((nav,i)=>{
                    const isActive = isNavigationActive(nav.link)

                    return (
                    <button key={i} type="button" className={navigationButtonClassName(isActive)}
                        aria-current={isActive ? 'page' : undefined}
                        onClick={()=> navigate(nav.link)}
                    >
                        {renderBottomNavIcon(nav.icon)}
                        <span className={bottomNavLabelClassName}>{nav.title}</span>
                    </button>
                    )
                })}
            </div>
        </div>
    )
}

export default Navigation
